module.exports = __webpack_public_path__ + "img/default.5731fc51.jpg";